import { useEffect, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import Table from "../../components/Table/Table";
import classes from "./Users.module.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import InputField from "../../components/ui/InputField/InputField";
import { env } from "../../constants/env";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showTableDialog, setShowTableDialog] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();
  const itemsPerPage = 10;

  const columns = [
    // { key: "id", label: "ID" },
    { key: "name", label: "NAME" },
    { key: "email", label: "EMAIL" },
    { key: "joinDate", label: "JOIN DATE" },
    { key: "bookings", label: "BOOKINGS" },
    { key: "status", label: "STATUS" },
  ];

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(`${env.apiUrl}/api/users`, {
          params: {
            page: currentPage,
            limit: itemsPerPage,
            search: searchTerm,
          },
        });

        setUsers(res.data.users);
        setPageCount(res.data.totalPages);
      } catch (err) {
        console.error("Failed to fetch users:", err);
      }
    };

    fetchUsers();
  }, [currentPage, searchTerm]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  return (
    <div className={classes.wrapper}>
      <InputField
        className="mb-3"
        search
        placeholder="Search users"
        inputContainerClass={classes.inputContainer}
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setCurrentPage(1); // Reset to first page on search
        }}
      />

      <Table
        dataType={"Users"}
        data={users}
        columns={columns}
        showDialog={showTableDialog}
        setShowDialog={setShowTableDialog}
        userInfo={() => navigate(`users-management/${users[selectedUser]?.id}`)}
        clickedIndex={setSelectedUser}
      />

      <div className="mt-4">
        <ReactPaginate
          previousLabel={
            <FaChevronLeft
              color={
                currentPage === 1
                  ? "var(--border-default)"
                  : "var(--text-secondary-color)"
              }
            />
          }
          nextLabel={
            <FaChevronRight
              color={
                currentPage === pageCount
                  ? "var(--border-default)"
                  : "var(--text-secondary-color)"
              }
            />
          }
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={1}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      </div>
    </div>
  );
};

export default Users;